import { useLang } from "@/context/LanguageContext";

// A grid of post/reply images with a simple lightbox-on-click (open in new tab).
export default function ThreadImages({ images }) {
  if (!images || images.length === 0) return null;
  return (
    <div className={`mt-3 grid gap-2 ${images.length === 1 ? "grid-cols-1 max-w-sm" : "grid-cols-2 sm:grid-cols-3"}`}>
      {images.map((src, i) => (
        <a key={i} href={src} target="_blank" rel="noreferrer" data-testid={`thread-image-${i}`}
          className="block overflow-hidden rounded border border-line">
          <img src={src} alt="" loading="lazy" className="h-40 w-full object-cover transition-transform hover:scale-105" />
        </a>
      ))}
    </div>
  );
}

export function PollComposer({ poll, setPoll }) {
  const { pick } = useLang();
  const setOpt = (i, v) => setPoll({ ...poll, options: poll.options.map((o, j) => (j === i ? v : o)) });
  return (
    <div className="mt-3 border border-line bg-parchment p-3" data-testid="poll-composer">
      <input value={poll.question} onChange={(e) => setPoll({ ...poll, question: e.target.value })}
        data-testid="poll-question-input" placeholder={pick("प्रश्न (वैकल्पिक)", "Poll question (optional)")}
        className="w-full border border-line bg-surface px-3 py-2 text-sm text-ink focus:border-saffron focus:outline-none" />
      <div className="mt-2 space-y-2">
        {poll.options.map((o, i) => (
          <div key={i} className="flex items-center gap-2">
            <input value={o} onChange={(e) => setOpt(i, e.target.value)} data-testid={`poll-option-${i}`}
              placeholder={`${pick("विकल्प", "Option")} ${i + 1}`}
              className="flex-1 border border-line bg-surface px-3 py-1.5 text-sm text-ink focus:border-saffron focus:outline-none" />
            {poll.options.length > 2 && (
              <button type="button" onClick={() => setPoll({ ...poll, options: poll.options.filter((_, j) => j !== i) })}
                className="text-xs text-ink-3 hover:text-red-600">✕</button>
            )}
          </div>
        ))}
      </div>
      <div className="mt-2 flex items-center justify-between">
        {poll.options.length < 8 && (
          <button type="button" onClick={() => setPoll({ ...poll, options: [...poll.options, ""] })}
            data-testid="poll-add-option" className="text-xs text-saffron hover:underline">+ {pick("विकल्प जोड़ें", "Add option")}</button>
        )}
        <label className="flex items-center gap-1.5 text-xs text-ink-2">
          <input type="checkbox" checked={poll.multi} onChange={(e) => setPoll({ ...poll, multi: e.target.checked })} data-testid="poll-multi" />
          {pick("एकाधिक चयन", "Allow multiple choices")}
        </label>
      </div>
    </div>
  );
}
